import {
	SET_TITHES,
	SET_TITHE,
	CLEAR_TITHES,
	CLEAR_TITHE,
	ADD_TITHE,
	UPDATE_TITHE,
	REMOVE_TITHE,
} from './actionTypes';

export const tithe = (state = {}, action) => {
	switch (action.type) {
		case SET_TITHE:
			return action.payload;
		case UPDATE_TITHE:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_TITHE:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_TITHES:
			return action.payload;
		case ADD_TITHE:
			return [...state, action.payload];
		case UPDATE_TITHE:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_TITHE:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_TITHES:
			return [];
		default:
			return state;
	}
};
